import React, { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { getDoctorStats } from "../../actions/adminAction";

const COLOR_PALETTE = [
  '#3B82F6', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6',
  '#06B6D4', '#84CC16', '#F97316', '#64748B', '#EC4899',
  '#A855F7', '#0EA5E9', '#22C55E', '#EAB308', '#F43F5E'
];

const DoctorStatChart = () => {
  const [state, setState] = useState({
    series: [],
    options: {
      colors: COLOR_PALETTE,
      chart: {
        type: 'bar',
        height: 350,
        width: "100%",
        stacked: true,
        toolbar: { show: false },
        zoom: { enabled: false },
        events: {
          dataPointSelection: (event, chartContext, config) => {
            console.log('Selected state:', config.seriesName);
          }
        }
      },
      // responsive: [{
      //   breakpoint: 480,
      //   options: {
      //     legend: { position: 'bottom', offsetX: -10, offsetY: 0 }
      //   }
      // }],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'last',
          dataLabels: {
            total: {
              enabled: true,
              style: { fontSize: '13px', fontWeight: 900 }
            },
            enabled: true,
            formatter: function(val, { seriesIndex }) {
              return state.series[seriesIndex]?.name?.substring(0, 3) + ': ' + val;
            },
            style: {
              colors: ['#fff']
            }
          }
        }
      },
      xaxis: {
        type: 'datetime',
        categories: [],
        labels: {
          datetimeFormatter: {
            year: 'yyyy',
            month: 'MMM \'yy',
            day: 'dd MMM'
          }
        }
      },
      legend: {
        position: 'right',
        offsetY: 40,
        // formatter: function(seriesName) {
        //   return seriesName + ' (' + state.series.find(s => s.name === seriesName)?.data.reduce((a,b) => a+b, 0) + ')';
        // }
      },
      fill: { opacity: 1 },
      tooltip: {
        shared: true,
        intersect: false,
        // y: {
        //   formatter: function(value, { series, dataPointIndex }) {



        //     const stateName = state.series[series]?.name;
        //     const date = new Date(state.options.xaxis.categories[dataPointIndex]).toDateString();
       

        //     return `${stateName}: ${value} appointments (${date})`;
        //   }
        // }
      }
    }
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getDoctorStats();
        const chartData = response.data.doctorChartData;
        const dates = [...new Set(chartData.map(item => item.date))].sort();
        const doctors = [...new Set(chartData.map(item => item.name))];
        const series = doctors.map(state => ({
          name: state,
          data: dates.map(date => {
            const entry = chartData.find(d => 
              d.date === date && d.name === state
            );
            return entry ? entry.totalAppointments : 0;
          })
        }));

        series.sort((a, b) => 
          b.data.reduce((sum, val) => sum + val, 0) - 
          a.data.reduce((sum, val) => sum + val, 0)
        );

        setState(prev => ({
          ...prev,
          series: series,
          options: {
            ...prev.options,
            xaxis: {
              ...prev.options.xaxis,
              categories: dates.map(date => new Date(date).getTime())
            }
          }
        }));

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="card-stats card chart-card">
      <div className="chart-card-header">
        <h4 class="card-title">Daily Prescriptions per Doctor</h4>
      </div>
      <div id="chart">
        <ReactApexChart 
          options={state.options} 
          series={state.series} 
          type="bar" 
         
        />
      </div>
    </div>
  );
};

export default DoctorStatChart;